module.exports = __webpack_public_path__ + "static/media/icono_panificacion.8d1acfa7.png";